module.exports = __webpack_public_path__ + "img/section6-2.8be02e05.png";